import Button from "elements/Button";
import React from "react";

export default function Size({ listSize }) {
  const [active, setActive] = React.useState();
  const [stock, setStock] = React.useState(0);

  // initial active
  React.useEffect(() => {
    if (listSize) {
      if (listSize.data.length > 0) {
        setActive(listSize.data[0].sizes.size);
        setStock(listSize.data[0].stock);
      }
    }
  }, [listSize]);

  const chooseSize = (size) => {
    setActive(size);
    listSize.data.map((item) => {
      if (item.sizes.size === size) {
        return setStock(item.stock);
      }
      return null;
    });
  };

  return (
    <div className="size mt-4">
      <h3>
        {listSize
          ? listSize.data.length > 0
            ? "Size Ready"
            : "No Available Size"
          : ""}
      </h3>
      <div className="size-ready justify-content-center">
        {listSize
          ? listSize.data.map((item, index) => {
              return (
                <Button
                  key={index}
                  className={`btn mx-2 my-2 ${
                    active === item.sizes.size
                      ? "btn-primary"
                      : "btn-outline-secondary"
                  }`}
                  onClick={() => chooseSize(item.sizes.size)}
                >
                  {item.sizes.size}
                </Button>
              );
            })
          : ""}
      </div>

      {/* STOCK */}
      <div className="mt-3">
        <h5>Stock : {stock}</h5>
      </div>
    </div>
  );
}
